import * as z from "zod";

// Campaign form schema
export const campaignFormSchema = z.object({
  name: z.string().min(1, "Campaign name is required"),
  meta: z.object({
    description: z.string().min(1, "Description is required"),
    theme: z.string().min(1, "Theme is required"),
    goals: z.array(z.string().min(1, "Goal cannot be empty")).min(1, "At least one goal is required"),
  }),
  active_from: z.date(),
  active_to: z.date(),
  is_active: z.boolean().default(true),
  additional_details: z.string().optional(),
});

export type CampaignFormValues = z.infer<typeof campaignFormSchema>;

export interface Location {
  country: string;
  state: string;
  district: string;
  volunteers: number;
  details: string;
}
